/* eslint-disable react/prop-types */
import React from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Select, { components } from 'react-select'

export const SECURE = 'secure'

export const sortAndRemoveDuplicates = (data) => {
  // eslint-disable-next-line no-param-reassign
  data = data.filter((v, i, a) => a.findIndex((t) => t.label === v.label) === i)
  data.sort((a, b) => a.label.localeCompare(b.label))
  return data
}

export const filterHelper = (compliantDataToFilter, nonCompliantField, filterOptions) => {
  if (filterOptions?.length) {
    // eslint-disable-next-line no-param-reassign
    compliantDataToFilter = compliantDataToFilter.filter((nonCompliant) =>
      filterOptions.some((option) => option.value === nonCompliant[`${nonCompliantField}`]),
    )
  }
  return compliantDataToFilter
}

export const getValueContainer = (ClearIndicator) => {
  function ValueContainer({ children, getValue, ...props }) {
    const { length } = getValue()
    return (
      <components.ValueContainer {...props}>
        {length === 1 && (
          <>
            <span className="multi-select-value">{props.selectProps.value[0].label}</span>
            <ClearIndicator {...props} />
          </>
        )}
        {length > 1 && (
          <>
            <span className="multi-select-value">{length}</span>
            <ClearIndicator {...props} />
            <components.Placeholder {...props} className="multi-select-label">
              {props.selectProps.placeholder}
            </components.Placeholder>
          </>
        )}
      </components.ValueContainer>
    )
  }
  return ValueContainer
}

export const getClearIndicator = (updateFilter) => {
  function ClearIndicator({ innerRef, children, ...props }) {
    const onClear = (e) => {
      switch (props.selectProps?.name) {
        case 'policyName':
        case 'action':
        case 'status':
          updateFilter(props.selectProps.name)
          break
        default:
          break
      }

      e.stopPropagation()
      e.preventDefault()
    }

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div ref={innerRef} className="multi-select-clear" onClick={onClear}>
        <components.ClearIndicator {...props}>
          <span className="icon-xs flaticon2-cross p-2" />
        </components.ClearIndicator>
      </div>
    )
  }
  return ClearIndicator
}

export function Option({ children, ...props }) {
  const { isSelected, label, value, isMulti, data } = props

  const onClick = (e) => {
    props.selectOption({ ...data })
    e.stopPropagation()
    e.preventDefault()
  }

  if (isMulti) {
    return (
      <components.Option {...props}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div className="multi-select-option" onClick={onClick}>
          <Form.Check readOnly className="multi-select-check" checked={isSelected} label={label} value={value} />
          {
            // Show count in option if not showing employees
            props.selectProps.name !== 'employee' && <span className="multi-select-count">{props.data.count}</span>
          }
        </div>
      </components.Option>
    )
  }
}

export const formatColumn = (cell, row, key) => <span>{row?.[key]}</span>

// eslint-disable-next-line consistent-return
export const formatArrayColumn = (cell, row, key) => {
  if (row?.[key]) {
    const returnArray = []
    let collapsed = ''

    for (let i = 0; i < row[key].length; i += 1) {
      // Ignore empty values (no chip) needs to be there for searching
      if (row[key] === 'empty') {
        break
      }
      if (i < 2) {
        returnArray.push(
          <div key={i} className="chip">
            {row[key][i]}
          </div>,
        )
      } else {
        collapsed += !collapsed.length ? row[key][i] : `, ${row[key][i]}`
      }
    }

    if (row[key][0] === 'empty') {
      return []
    }

    const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        {collapsed}
      </Tooltip>
    )

    if (row[key].length > 2) {
      returnArray.push(
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
          <div key={2} className="chip">
            +{row[key].length - 2}
          </div>
        </OverlayTrigger>,
      )
    }
    return returnArray
  }
}

export const getSelectableColumnHeaderFormatter = (
  id,
  ref,
  name,
  styles,
  menuIsOpen,
  options,
  value,
  placeholder,
  onClickHandler,
  onChangeHandler,
  // eslint-disable-next-line no-shadow
  components,
) => {
  const headerFormatter = () => (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="select-container" onClick={(e) => onClickHandler(name, e)}>
      <Select
        id={id}
        ref={ref}
        autoBlur
        name={name}
        classNamePrefix="multi-select"
        styles={styles}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        menuIsOpen={menuIsOpen}
        options={options}
        value={value}
        // eslint-disable-next-line no-shadow
        onChange={(value) => onChangeHandler(name, value)}
        placeholder={placeholder}
        isClearable={false}
        isSearchable
        components={components}
      />
    </div>
  )
  return headerFormatter
}

export const getColumnHeaderClickHandler = (refs, showMenus, setShowMenus) => {
  const handleClick = (target) => {
    if (showMenus[target]) {
      setShowMenus[target](false)
      if (refs[target].current.select.inputRef) {
        refs[target].current.select.inputRef.blur()
      }
    } else {
      setShowMenus[target](true)
    }
  }
  return handleClick
}

export const getHandleClickOutside = (refs, setShowMenus) => {
  const handleClickOutside = (event) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(refs)) {
      if (
        value.current &&
        !value.current.select.controlRef.contains(event.target) &&
        !value.current.select?.focusedOptionRef?.contains(event.target)
      ) {
        setShowMenus[key](false)
        if (value.current.select.inputRef) {
          value.current.select.inputRef.blur()
        }
      }
    }
  }

  return handleClickOutside
}
